import React from "react";
import { useTranslation } from "react-i18next";
import KPIDoughnutChart from "./KPIDoughnutChart";
import styles from "../../pages/Welcome/style.module.scss";

/**
 * Metric 12: overall intent doughnut + second doughnut for composition inside
 * mixed-intent reviews (unique intents per review, same logic as console intent=33).
 */
const WelcomeDualIntentDoughnutCharts = ({ data, theme }) => {
  const { t } = useTranslation();
  const primary = data?.primary;
  const mixed = data?.mixed_breakdown;
  const labels = primary?.labels || [];
  const primaryData = primary?.datasets?.[0]?.data || [];
  const mixedIdx = labels.findIndex(
    (lb) => String(lb || "").trim().toLowerCase() === "mixed",
  );
  const mixedSlicePct =
    mixedIdx >= 0 && mixedIdx < primaryData.length
      ? Number(primaryData[mixedIdx]) || 0
      : 0;
  const mixedInnerSum = (mixed?.datasets?.[0]?.data || []).reduce(
    (acc, v) => acc + (Number(v) > 0 ? Number(v) : 0),
    0,
  );
  const showMixedColumn = mixedSlicePct > 0 && mixedInnerSum > 0;
  const customLabels =
    primary?.legend && Array.isArray(primary.legend)
      ? primary.legend.map((item) => item.count)
      : null;
  const mixedCustomLabels =
    mixed?.legend && Array.isArray(mixed.legend)
      ? mixed.legend.map((item) => item.count)
      : null;

  return (
    <div
      className={`${styles.welcomeDualSentimentRow} ${
        !showMixedColumn ? styles.welcomeDualSentimentRowSingle : ""
      }`.trim()}
    >
      <div className={styles.welcomeDualSentimentCol}>
        <div className={styles.welcomeDualSentimentChartTitle}>
          {t("welcome.intentDistPrimaryTitle")}
        </div>
        <KPIDoughnutChart
          data={primary}
          theme={theme}
          showLegend
          customLabels={customLabels}
        />
      </div>
      {showMixedColumn && (
        <div className={styles.welcomeDualSentimentCol}>
          <div className={styles.welcomeDualSentimentChartTitle}>
            {t("welcome.intentDistMixedTitle")}
          </div>
          <KPIDoughnutChart
            data={mixed}
            theme={theme}
            showLegend
            customLabels={mixedCustomLabels}
          />
        </div>
      )}
    </div>
  );
};

export default WelcomeDualIntentDoughnutCharts;
